// @ts-expect-error - we are using React 17 types but have 18 installed
import {useEffect, useState, useSyncExternalStore} from 'react'

const subscribe = () => () => {}
const getSnapshot = () => true
const getServerSnapshot = () => false

/**
 * Check whether the app has been hydrated on the client side.
 * Use this hook to defer rendering any layout that relies on client-side state.
 * It will not render on the server OR on the first client render to avoid hydration issues.
 * @returns boolean
 */
export const useIsHydrated = () => {
  const isHydratedInitialState = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot
  )
  const [isHydrated, setIsHydrated] = useState(isHydratedInitialState)

  useEffect(() => {
    if (!isHydrated) {
      setIsHydrated(true)
    }
  }, [isHydrated])

  return isHydrated
}
